import { throttle } from "lodash-es";
import React, { memo, useEffect, useState } from "react";

const THROTTLE_DELAY = 250;
const getAppState = () => {
  return {
    isMobile: !!window.matchMedia("(max-width: 1024px)").matches,
    isLandscapeMode: Math.abs(window.orientation) === 90,
  };
};

export const ProjectContext = React.createContext(getAppState());

const RootContext = ({ children }) => {
  const [state, setState] = useState(getAppState());

  const updateState = throttle(() => {
    const newState = getAppState();
    if (JSON.stringify(newState) !== JSON.stringify(state)) {
      setState(newState);
    }
  }, THROTTLE_DELAY);

  useEffect(() => {
    window.addEventListener("resize", updateState);
    window.addEventListener("orientationchange", updateState);
    return () => {
      window.removeEventListener("resize", updateState);
      window.removeEventListener("orientationchange", updateState);
    };
  }, [updateState]);

  return (
    <ProjectContext.Provider value={state}>{children}</ProjectContext.Provider>
  );
};

export const Context = memo(RootContext);
